export default __webpack_public_path__ + "static/media/smart.a7b49770.svg";